<div class="close" (click)="close()">
  <img
    alt="close"
    width="24"
    height="24"
    src="../../../../assets/images/close.svg"
  />
</div>
<div class="detail">
  <div mat-dialog-content>
    <div class="part1">跨年狂欢季</div>
    <div class="part2">即日起至2026/01/07</div>
    <div class="part3">
      <img src="../../../../assets/images/discount/platform1.png" alt="" />
      <div class="left">
        <div class="txt1">Adobe 全家桶</div>
        <div class="txt2">正版授权&nbsp;稳定更新</div>
      </div>
      <div class="right">8折优惠</div>
    </div>
    <div class="part3">
      <img src="../../../../assets/images/discount/platform2.png" alt="" />
      <div class="left">
        <div class="txt1">ChatGPT Plus</div>
        <div class="txt2">极速响应&nbsp;独享体验</div>
      </div>
      <div class="right">8折优惠</div>
    </div>
    <div class="part4">
      <div class="code">优惠码：<span>2026</span></div>
      <div class="copy" (click)="copy('2026')">
        <img src="../../../../assets/images/discount/fuzhi.png" alt="" />复制
      </div>
    </div>
    <div class="part5" matRipple (click)="close()">立即领取优惠</div>
    <div class="part6">*新老用户通用·续费不可用</div>
  </div>
</div>
